import React from 'react';
import PropTypes from 'prop-types';
import { SearchFilterList } from '@src/components/core/core-component-imports.js';
import PageCategoryFilter from '@src/components/search-results/page-category-filter.jsx';
import BlogCategoryFilter from "@src/components/search-results/blog-category-filter.jsx";

/**
 * Renders all search filters for the global search results page.
 */
const GlobalFilterList = ({
  selectionHandler,
  allResultsCount,
  conditionResultsCount,
  leadershipResultsCount,
  locationResultsCount,
  providerResultsCount,
  researchResultsCount,
  serviceResultsCount,
  specialtyResultsCount,
  treatmentResultsCount,
  blogResultsCount,
  hideBlogCategoryFilter,
}) => {
  const pageCategoryFilter = ({ open, clickHandler }) => {
    return (
      <PageCategoryFilter
        open={open}
        clickHandler={clickHandler}
        selectionHandler={selectionHandler}
        allResultsCount={allResultsCount}
        conditionResultsCount={conditionResultsCount}
        leadershipResultsCount={leadershipResultsCount}
        locationResultsCount={locationResultsCount}
        providerResultsCount={providerResultsCount}
        researchResultsCount={researchResultsCount}
        serviceResultsCount={serviceResultsCount}
        specialtyResultsCount={specialtyResultsCount}
        treatmentResultsCount={treatmentResultsCount}
        blogResultsCount={blogResultsCount}
      />
    );
  };

  const blogCategoryFilter = ({ open, clickHandler }) => {
    return (
      <BlogCategoryFilter
        open={open}
        clickHandler={clickHandler}
        selectionHandler={selectionHandler}
        hidden={hideBlogCategoryFilter}
      />
    );
  };

  return (
    <SearchFilterList
      searchFilters={[
        pageCategoryFilter,
        blogCategoryFilter
      ]}
    />
  );
}

GlobalFilterList.propTypes = {
  /**
   * the callback function for when a selection is made
   */
  selectionHandler: PropTypes.func.isRequired,
  /**
   * the total number of results
   */
  allResultsCount: PropTypes.number.isRequired,
  /**
   * the number of condition results
   */
  conditionResultsCount: PropTypes.number.isRequired,
  /**
   * the number of leadership results
   */
  leadershipResultsCount: PropTypes.number.isRequired,
  /**
   * the number of location results
   */
  locationResultsCount: PropTypes.number.isRequired,
  /**
   * the number of provider results
   */
  providerResultsCount: PropTypes.number.isRequired,
  /**
   * the number of research results
   */
  researchResultsCount: PropTypes.number.isRequired,
  /**
   * the number of service results
   */
  serviceResultsCount: PropTypes.number.isRequired,
  /**
   * the number of specialty results
   */
  specialtyResultsCount: PropTypes.number.isRequired,
  /**
   * the number of treatment results
   */
  treatmentResultsCount: PropTypes.number.isRequired,
  /**
   * controls whether blog categories are hidden or visible
   */
  hideBlogCategoryFilter: PropTypes.bool,
};

export default GlobalFilterList;
